import { ACTION } from '../../../common/const/lei-products';

// Longest first, so CLAIM_RENEW and TRANSFER_RENEW match before a shorter action could.
const DRAFT_ACTIONS = Object.values(ACTION).sort((a, b) => b.length - a.length);

/**
 * Splits a draft key (`<emailHash>_<ACTION>[_<id>]`, see DraftCacheKey) into { type, keyForAction }.
 * Actions such as CLAIM_RENEW contain '_', so the action is matched against the known list rather
 * than split on '_'. Returns undefined when the key is not one of this user's drafts.
 */
export function parseDraftKey(draftKey, hashedEmail) {
  const prefix = hashedEmail + '_';
  if (!hashedEmail || typeof draftKey !== 'string' || !draftKey.startsWith(prefix)) {
    return undefined;
  }

  const rest = draftKey.slice(prefix.length);
  const type = DRAFT_ACTIONS.find(action => rest === action || rest.startsWith(action + '_'));
  if (type) {
    return { type, keyForAction: rest.slice(type.length + 1) };
  }

  // Unknown action: keep the previous split-on-'_' behavior.
  const parts = rest.split('_');
  return { type: parts[0], keyForAction: parts.length > 1 ? parts[1] : '' };
}
